import { SimpleDataProvider } from 'components/system';
import { CustomerChangeSubType, CustomerChangeSubTypeOptions, RsCustomerInfo, forceEnum } from './types';

export class CustomerChangeSubTypeDataProvider extends SimpleDataProvider {
    constructor() {
        super();
    }

    public commit(customerId, data: CustomerChangeSubType, force: forceEnum = null): Promise<RsCustomerInfo> {
        let url = `middle://rs/customers/${customerId}/sub-type`;

        if (force) {
            url += '/force';
            data.force = force;
        }

        return this.service.updateRequest<RsCustomerInfo>(url, 'PUT', data);
    }

    public params(customerId, subTypeId): Promise<CustomerChangeSubTypeOptions> {
        const params = {
            subTypeId: subTypeId
        };

        return this.service.getItem<CustomerChangeSubTypeOptions>(`middle://rs/customers/${customerId}/sub-type/params`, params);
    }
}
